class CartRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        new IntersectionObserver(this.handleIntersection.bind(this)).observe(this)
    }
    handleIntersection(e, t) {
        e[0].isIntersecting && (t.unobserve(this), fetch(this.dataset.url + '&intent=complementary').then((e => e.text())).then((e => {
            if (e.includes('<li class="swiper-slide">')) {
                const t = document.createElement("div");
                t.innerHTML = e;
                const n = t.querySelector("cart-recommendations");
                n && n.innerHTML.trim().length && (this.innerHTML = n.innerHTML);
                
                new Swiper('.cart-recommendations-slider', {
                    loop: false,
                    navigation: {
                        nextEl: `.swiper-button-next`,
                        prevEl: `.swiper-button-prev`,
                    },
                    slidesPerView: 2.2,
                    paginationClickable: true,
                    spaceBetween: 15,
                    breakpoints: {
                        749: {
                            slidesPerView: 2.7
                        },
                        450: {
                            slidesPerView: 3
                        },
                    },
                });
            } else {
                fetch(this.dataset.url).then((e => e.text())).then((e => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const n = t.querySelector("cart-recommendations");
                    n && n.innerHTML.trim().length && (this.innerHTML = n.innerHTML);
                    
                    new Swiper('.cart-recommendations-slider', {
                        loop: false,
                        navigation: {
                            nextEl: `.swiper-button-next`,
                            prevEl: `.swiper-button-prev`,
                        },
                        slidesPerView: 1.5,
                        paginationClickable: true,
                        spaceBetween: 15,
                        breakpoints: {
                            749: {
                                slidesPerView: 2.7
                            },
                            450: {
                                slidesPerView: 3
                            },
                        },
                    });
                })).catch((e => {
                    console.error(e)
                }))
            }
        })).catch((e => {
            console.error(e)
        })))
    }
}
customElements.define("cart-recommendations", CartRecommendations);